import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { StyledSmallSectionHeader } from 'containers/AMCDashboard/MyContracts/styles';
import CustomCarousel from 'components/CustomCarousel';
import messages from 'containers/AMCDashboard/messages';
import { translate } from 'helpers/intl';
import { AMCInfoCard } from 'components/ItemInfoCard';

const MyContracts = (props: {
  intl: IntlShape;
  contracts: any;
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CustomCarousel showIndicators={props.contracts.length > 1}>
        {props.contracts.map(
          (
            contract: {
              CIN: string;
              NUM_POLICE: string;
              NOM_SOUSCRIPTEUR: string;
              deadline: string;
              status: string;
            },
            index: any,
          ) => (
            <AMCInfoCard
              key={index}
              title={contract.NUM_POLICE}
              firstInformationLabel={translate(
                { ...messages.organisme },
                props,
              )}
              firstInformationValue={
                contract.NOM_SOUSCRIPTEUR?.substring(0, 30) + '...'
              }
              secondInformationLabel={translate({ ...messages.id }, props)}
              secondInformationValue={contract.CIN}
              wrapperPaddingRight={
                index === props.contracts.length - 1 ? '24px' : '45px'
              }
              wrapperPaddingLeft={index === 0 ? '24px' : '45px'}
              setDetailsPageBreadcrumbsPath={
                props.setDetailsPageBreadcrumbsPath
              }
            />
          ),
        )}
      </CustomCarousel>
    </>
  );
};

export default injectIntl(MyContracts);
